module.exports = __webpack_public_path__ + "072e5cad4cebef1f30eeafa8792b0447.svg";